import type { LogEntry } from "./types";
import { LogLevel } from "./types";
import { getConfig } from "./config";

let buffer: LogEntry[] = [];
let head = 0;
let count = 0;

function maxSize(): number {
  return getConfig().historySize;
}

export function pushHistory(entry: LogEntry): void {
  const max = maxSize();
  if (max <= 0) return;

  if (buffer.length < max) {
    buffer.push(entry);
  } else {
    buffer[head] = entry;
  }
  head = (head + 1) % max;
  count = Math.min(count + 1, max);
}

export function getLogHistory(): LogEntry[] {
  const max = maxSize();
  if (count < max) {
    return buffer.slice(0);
  }
  return [...buffer.slice(head), ...buffer.slice(0, head)];
}

export function clearLogHistory(): void {
  buffer = [];
  head = 0;
  count = 0;
}

export function getHistoryByLevel(level: LogLevel): LogEntry[] {
  return getLogHistory().filter((e) => e.level === level);
}

export function getHistoryByNamespace(namespace: string): LogEntry[] {
  return getLogHistory().filter((e) => e.namespace === namespace);
}
